import { Box, Checkbox, ScrollArea, Table, Text } from "@mantine/core";
import { IconGift } from "@tabler/icons-react";
import React from "react";
import {
  itemGiftPromotionModel,
  TblItemPromotionModel,
} from "../../../../../model/TblItem";

interface GiftTableProps {
  selectedPromotion: TblItemPromotionModel;
  setListSelectedGift: React.Dispatch<
    React.SetStateAction<itemGiftPromotionModel[]>
  >;
  listSelectedGift: itemGiftPromotionModel[];
}

const GiftTable: React.FC<GiftTableProps> = ({
  selectedPromotion,
  listSelectedGift,
  setListSelectedGift,
}) => {
  const handleCheckboxChange = (promotionItem: itemGiftPromotionModel) => {
    setListSelectedGift((prevList) => {
      const itemModel = (promotionItem as any).itemForSellModel;
      const warehouseId = itemModel?.warehouseId;
      
      const isAlreadySelected = prevList.some(
        (item) => 
          item.idItemGift === promotionItem.idItemGift && 
          (item as any).itemForSellModel?.warehouseId === warehouseId
      );
      
      if (isAlreadySelected) {
        // Nếu đã chọn, loại bỏ khỏi danh sách (check cả idItemGift và warehouseId)
        return prevList.filter(
          (item) => 
            !(item.idItemGift === promotionItem.idItemGift && 
              (item as any).itemForSellModel?.warehouseId === warehouseId)
        );
      } else {
        // Nếu chưa chọn, thêm vào danh sách
        return [...prevList, promotionItem];
      }
    });
  };

  return (
    <ScrollArea h={500}>
      <Table striped highlightOnHover stickyHeader>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Mã sản phẩm</Table.Th>
            <Table.Th>Mã kho</Table.Th>
            <Table.Th>Tên sản phẩm</Table.Th>
            <Table.Th>Đơn vị tính</Table.Th>
            <Table.Th>Tồn kho</Table.Th>
            <Table.Th>SL khả dụng</Table.Th>
            <Table.Th>Kho</Table.Th>
            <Table.Th>Chọn</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {(() => {
            const giftItems = selectedPromotion?.tblPromotionItemGift || [];
            const parents = giftItems.filter(
              (item) => !(item as any).attribute2
            );
            const children = giftItems.filter(
              (item) => !!(item as any).attribute2
            );
            const orderedItems: itemGiftPromotionModel[] = [];
            const usedChildIds = new Set<number>();

            parents.forEach((parent) => {
              orderedItems.push(parent);
              const parentModels = (parent as any).itemForSellModels || [];
              const parentCodes = new Set(
                parentModels.map((model: any) => model.productCode)
              );

              children.forEach((child) => {
                const childAttribute2 = (child as any).attribute2 as
                  | string
                  | null
                  | undefined;
                if (childAttribute2 && parentCodes.has(childAttribute2)) {
                  orderedItems.push(child);
                  usedChildIds.add(child.id);
                }
              });
            });

            children.forEach((child) => {
              if (!usedChildIds.has(child.id)) {
                orderedItems.push(child);
              }
            });

            return orderedItems;
          })().flatMap((promotionItem) => {
            // Sử dụng itemForSellModels (mảng) thay vì itemForSellModel (object)
            const itemWithModels = promotionItem as any;
            const sellModels = itemWithModels?.itemForSellModels || [];
            const attribute2 = (promotionItem as any).attribute2 as
              | string
              | null
              | undefined;
            const isChildGift = !!attribute2;
            
            return sellModels.map((sellModel: any, index: number) => {
              const availableQuantity = sellModel?.tons - sellModel?.tonao;
              const isOutOfStock = availableQuantity <= 0;

              // Tạo promotionItem tương ứng với sellModel hiện tại
              const currentPromotionItem: itemGiftPromotionModel = {
                ...promotionItem,
                idItemGift: sellModel.id,
                itemForSellModel: sellModel,
              };

              return (
                <Table.Tr
                  key={`${promotionItem?.id}-${sellModel?.id}-${index}`}
                  style={isOutOfStock ? { opacity: 0.6 } : undefined}
                >
                  <Table.Td>
                    <Box style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      {isChildGift && (
                        <IconGift size={14} color="#d9480f" />
                      )}
                      <Text size="sm" fw={isChildGift ? 400 : 600}>
                        {sellModel?.productCode}
                      </Text>
                    </Box>
                  </Table.Td>
                  <Table.Td>
                    {sellModel?.wareHouseCode}
                  </Table.Td>
                  <Table.Td>
                    <Box>
                      <Text size="sm" fw={isChildGift ? 400 : 600}>
                        {sellModel?.productName}
                      </Text>
                      {isChildGift && (
                        <Text size="xs" c="dimmed">
                          Quà thay thế cho: {attribute2}
                        </Text>
                      )}
                    </Box>
                  </Table.Td>
                  <Table.Td>{sellModel?.unit}</Table.Td>
                  <Table.Td>{sellModel?.tons}</Table.Td>
                  <Table.Td>
                    {availableQuantity}
                  </Table.Td>
                  <Table.Td>{sellModel?.warehouse}</Table.Td>
                  <Table.Td>
                    {isOutOfStock ? (
                      <Text size="sm" c="red">
                        Hết hàng
                      </Text>
                    ) : (
                      <Checkbox
                        checked={listSelectedGift.some(
                          (item) => 
                            item.idItemGift === sellModel.id && 
                            (item as any).itemForSellModel?.warehouseId === sellModel.warehouseId
                        )}
                        onChange={() => handleCheckboxChange(currentPromotionItem)}
                      />
                    )}
                  </Table.Td>
                </Table.Tr>
              );
            });
          })}
        </Table.Tbody>
      </Table>
    </ScrollArea>
  );
};

export default GiftTable;
